import { MapitStateContext, changeMapStyle } from "src/states/MapitState";
// import OrthoPhoto from "/images/OrthoView.png"
import { useContext } from "react";
import { BuiltInStyleMods } from "src/managers/LinkToMapStyle";
type props = {
  current?: string
  onSetBgLayer?: (e: "Map" | "Orthophoto") => void,
  onOpenStyle?: () => void
  anchor?: "normal" | "bottomLeft"
}

export function QuickOrthoPhoto(props: props) {
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
  let anchor = props.anchor ?? "normal"

  function toogleMod(mod: BuiltInStyleMods) {
    let mods = [...mapitState.mapInfo.mapStyle.mods ?? []]
    if (mods.includes(mod)) {
      mods = mods.filter((m) => m != mod)
    } else {
      mods.push(mod)
    }
    mapitStateDispatch(changeMapStyle({ mods }, true))
  }

  function isSelected(mod: BuiltInStyleMods) {
    let mods = mapitState.mapInfo.mapStyle.mods ?? []
    return mods.includes(mod)
  }

  function handleOnClick() {

    if ("current" in props) {
      const next = props.current === "Orthophoto" ? "Map" : "Orthophoto";
      props.onSetBgLayer?.(next)
    } else {
      toogleMod("Ortophoto")
    }
  }

  return (
    <div onClick={handleOnClick} className={"QuickOrthoPhoto " + anchor}>
      <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} src={new URL("/QuickOrtoFoto/kort.png", import.meta.url).href} />
      <img onMouseDown={(e) => e.preventDefault?.()} onTouchStart={(e) => e.preventDefault?.()} style={{ opacity: !(isSelected("Ortophoto")) ? 1 : 0 }} src={new URL("/QuickOrtoFoto/ortofoto.png", import.meta.url).href} />
    </div>
  )
}